import { Occurrence } from "../../models/occurrence";

export class GetOccurrences {
    static occurrences: Occurrence[] = [
            {
                "ONRSRRef": 548950,
                "OperatorRef": 768808,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-01T00:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "286.6",
                "OccurrenceTypes": "Derailment",
                "NDSOccurrenceId": 385578,
                "LineSectionId": 480768,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 673744,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 883332,
                "OperatorRef": 366094,
                "OccurrenceStatusId": 7,
                "OccurrenceStatus": "Draft",
                "ValidationStatus": "Draft",
                "ValidationStatusId": "0",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-02T13:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Adelaide",
                "State": "South Australia",
                "KmPoint": "442.1",
                "OccurrenceTypes": "Level Crossing Irregularity",
                "NDSOccurrenceId": 547534,
                "LineSectionId": 122457,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 334719,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "SA"
                }
            },
            {
                "ONRSRRef": 254871,
                "OperatorRef": 185806,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-03T20:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Brisbane",
                "State": "Queensland",
                "KmPoint": "197.0",
                "OccurrenceTypes": "Level Crossing Irregularity",
                "NDSOccurrenceId": 711017,
                "LineSectionId": 568595,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "QLD"
                }
            },
            {
                "ONRSRRef": 100102,
                "OperatorRef": 943039,
                "OccurrenceStatusId": 5,
                "OccurrenceStatus": "Awaiting Further Information",
                "ValidationStatus": "Incomplete",
                "ValidationStatusId": "3",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-04T05:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Darwin",
                "State": "Northern Territory",
                "KmPoint": "350.7",
                "OccurrenceTypes": "Fire, Explosion, Dangerous Goods",
                "NDSOccurrenceId": 127473,
                "LineSectionId": 614865,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 194014,
                "IsLocationMissing": false,
                "LocationDescription": "Near Adelaide\u2013Melbourne Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "NT"
                }
            },
            {
                "ONRSRRef": 810833,
                "OperatorRef": 404808,
                "OccurrenceStatusId": 7,
                "OccurrenceStatus": "Draft",
                "ValidationStatus": "Draft",
                "ValidationStatusId": "0",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-05T10:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Brisbane",
                "State": "Queensland",
                "KmPoint": "337.3",
                "OccurrenceTypes": "Fire, Explosion, Dangerous Goods",
                "NDSOccurrenceId": 816926,
                "LineSectionId": 411395,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 929683,
                "IsLocationMissing": false,
                "LocationDescription": "Near Adelaide\u2013Melbourne Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "QLD"
                }
            },
            {
                "ONRSRRef": 149860,
                "OperatorRef": 215319,
                "OccurrenceStatusId": 7,
                "OccurrenceStatus": "Draft",
                "ValidationStatus": "Draft",
                "ValidationStatusId": "0",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-06T10:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "333.6",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 482364,
                "LineSectionId": 898962,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 902478,
                "OperatorRef": 906710,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-07T00:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Darwin",
                "State": "Northern Territory",
                "KmPoint": "315.1",
                "OccurrenceTypes": "Collision/Near Hit",
                "NDSOccurrenceId": 995794,
                "LineSectionId": 223783,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 575337,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "NT"
                }
            },
            {
                "ONRSRRef": 454966,
                "OperatorRef": 408736,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-08T07:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "Australian Capital Territory",
                "KmPoint": "220.9",
                "OccurrenceTypes": "Rolling Stock Irregularity",
                "NDSOccurrenceId": 299199,
                "LineSectionId": 628356,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 301772,
                "IsLocationMissing": false,
                "LocationDescription": "Near Adelaide\u2013Melbourne Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "ACT"
                }
            },
            {
                "ONRSRRef": 239306,
                "OperatorRef": 916014,
                "OccurrenceStatusId": 4,
                "OccurrenceStatus": "Final",
                "ValidationStatus": "Validated",
                "ValidationStatusId": "4",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-09T17:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Darwin",
                "State": "Northern Territory",
                "KmPoint": "266.1",
                "OccurrenceTypes": "Fire, Explosion, Dangerous Goods",
                "NDSOccurrenceId": 389244,
                "LineSectionId": 666787,
                "LineSectionName": "Main North Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 512140,
                "IsLocationMissing": false,
                "LocationDescription": "Near Main North Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Main North Line",
                    "LocationLine2": "",
                    "LocationLine3": "NT"
                }
            },
            {
                "ONRSRRef": 362343,
                "OperatorRef": 252690,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-10T09:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "Australian Capital Territory",
                "KmPoint": "13.4",
                "OccurrenceTypes": "Derailment",
                "NDSOccurrenceId": 942301,
                "LineSectionId": 409625,
                "LineSectionName": "North Coast Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "North Coast Line",
                    "LocationLine2": "",
                    "LocationLine3": "ACT"
                }
            },
            {
                "ONRSRRef": 347473,
                "OperatorRef": 802174,
                "OccurrenceStatusId": 4,
                "OccurrenceStatus": "Final",
                "ValidationStatus": "Validated",
                "ValidationStatusId": "4",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-11T18:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "Australian Capital Territory",
                "KmPoint": "467.7",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 687864,
                "LineSectionId": 788150,
                "LineSectionName": "Main North Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 808588,
                "IsLocationMissing": false,
                "LocationDescription": "Near Main North Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Main North Line",
                    "LocationLine2": "",
                    "LocationLine3": "ACT"
                }
            },
            {
                "ONRSRRef": 351472,
                "OperatorRef": 246750,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-12T04:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Adelaide",
                "State": "South Australia",
                "KmPoint": "73.6",
                "OccurrenceTypes": "Collision/Near Hit",
                "NDSOccurrenceId": 549458,
                "LineSectionId": 138482,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 488589,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "SA"
                }
            },
            {
                "ONRSRRef": 721427,
                "OperatorRef": 891987,
                "OccurrenceStatusId": 5,
                "OccurrenceStatus": "Awaiting Further Information",
                "ValidationStatus": "Incomplete",
                "ValidationStatusId": "3",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-13T18:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Perth",
                "State": "Western Australia",
                "KmPoint": "75.6",
                "OccurrenceTypes": "Derailment",
                "NDSOccurrenceId": 590789,
                "LineSectionId": 397546,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 978791,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "WA"
                }
            },
            {
                "ONRSRRef": 786090,
                "OperatorRef": 569550,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-14T19:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "403.4",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 609472,
                "LineSectionId": 921143,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 867597,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 776735,
                "OperatorRef": 164887,
                "OccurrenceStatusId": 5,
                "OccurrenceStatus": "Awaiting Further Information",
                "ValidationStatus": "Incomplete",
                "ValidationStatusId": "3",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-15T07:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "276.0",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 189105,
                "LineSectionId": 543969,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 708286,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 461004,
                "OperatorRef": 298471,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-16T01:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Brisbane",
                "State": "Queensland",
                "KmPoint": "53.4",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 393918,
                "LineSectionId": 358901,
                "LineSectionName": "North Coast Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 968798,
                "IsLocationMissing": false,
                "LocationDescription": "Near North Coast Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "North Coast Line",
                    "LocationLine2": "",
                    "LocationLine3": "QLD"
                }
            },
            {
                "ONRSRRef": 579518,
                "OperatorRef": 517142,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-17T00:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Adelaide",
                "State": "South Australia",
                "KmPoint": "14.0",
                "OccurrenceTypes": "Collision/Near Hit",
                "NDSOccurrenceId": 668858,
                "LineSectionId": 330787,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 335852,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "SA"
                }
            },
            {
                "ONRSRRef": 150127,
                "OperatorRef": 159873,
                "OccurrenceStatusId": 5,
                "OccurrenceStatus": "Awaiting Further Information",
                "ValidationStatus": "Incomplete",
                "ValidationStatusId": "3",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-18T00:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "69.8",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 731913,
                "LineSectionId": 730415,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 204626,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 499186,
                "OperatorRef": 995459,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-19T09:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "266.7",
                "OccurrenceTypes": "Fire, Explosion, Dangerous Goods",
                "NDSOccurrenceId": 638281,
                "LineSectionId": 312507,
                "LineSectionName": "Geelong Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 615700,
                "IsLocationMissing": false,
                "LocationDescription": "Near Geelong Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Geelong Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 675231,
                "OperatorRef": 553465,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-20T10:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Darwin",
                "State": "Northern Territory",
                "KmPoint": "378.8",
                "OccurrenceTypes": "Track Irregularity",
                "NDSOccurrenceId": 689372,
                "LineSectionId": 487235,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 489301,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "NT"
                }
            },
            {
                "ONRSRRef": 943295,
                "OperatorRef": 525733,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-21T23:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "80.8",
                "OccurrenceTypes": "Collision/Near Hit",
                "NDSOccurrenceId": 306797,
                "LineSectionId": 138140,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 926988,
                "IsLocationMissing": false,
                "LocationDescription": "Near Adelaide\u2013Melbourne Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 442109,
                "OperatorRef": 617765,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-22T04:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "181.8",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 542178,
                "LineSectionId": 412565,
                "LineSectionName": "North Coast Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "North Coast Line",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 508163,
                "OperatorRef": 910925,
                "OccurrenceStatusId": 7,
                "OccurrenceStatus": "Draft",
                "ValidationStatus": "Draft",
                "ValidationStatusId": "0",
                "OccurrenceCategory": "B",
                "OccurrenceDateTime": "2025-01-23T13:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "141.2",
                "OccurrenceTypes": "Track Irregularity",
                "NDSOccurrenceId": 300348,
                "LineSectionId": 573287,
                "LineSectionName": "Main North Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 871068,
                "IsLocationMissing": false,
                "LocationDescription": "Near Main North Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Main North Line",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 621723,
                "OperatorRef": 671895,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-24T16:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Perth",
                "State": "Western Australia",
                "KmPoint": "456.4",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 990852,
                "LineSectionId": 514464,
                "LineSectionName": "Adelaide\u2013Melbourne Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Adelaide\u2013Melbourne Line",
                    "LocationLine2": "",
                    "LocationLine3": "WA"
                }
            },
            {
                "ONRSRRef": 170000,
                "OperatorRef": 951323,
                "OccurrenceStatusId": 7,
                "OccurrenceStatus": "Draft",
                "ValidationStatus": "Draft",
                "ValidationStatusId": "0",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-25T15:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Darwin",
                "State": "Northern Territory",
                "KmPoint": "177.1",
                "OccurrenceTypes": "Network Rule or Procedure Breach",
                "NDSOccurrenceId": 166244,
                "LineSectionId": 235783,
                "LineSectionName": "Main North Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 602268,
                "IsLocationMissing": false,
                "LocationDescription": "Near Main North Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Main North Line",
                    "LocationLine2": "",
                    "LocationLine3": "NT"
                }
            },
            {
                "ONRSRRef": 421899,
                "OperatorRef": 369268,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-26T02:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Brisbane",
                "State": "Queensland",
                "KmPoint": "313.5",
                "OccurrenceTypes": "Level Crossing Irregularity",
                "NDSOccurrenceId": 956709,
                "LineSectionId": 752881,
                "LineSectionName": "North Coast Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 561580,
                "IsLocationMissing": false,
                "LocationDescription": "Near North Coast Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "North Coast Line",
                    "LocationLine2": "",
                    "LocationLine3": "QLD"
                }
            },
            {
                "ONRSRRef": 223625,
                "OperatorRef": 852151,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-27T13:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "395.2",
                "OccurrenceTypes": "Rolling Stock Irregularity",
                "NDSOccurrenceId": 872315,
                "LineSectionId": 929992,
                "LineSectionName": "North Coast Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 0,
                "IsLocationMissing": true,
                "LocationDescription": "Location under investigation",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "North Coast Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 465883,
                "OperatorRef": 131232,
                "OccurrenceStatusId": 1,
                "OccurrenceStatus": "Submitted",
                "ValidationStatus": "Pending",
                "ValidationStatusId": "1",
                "OccurrenceCategory": "N",
                "OccurrenceDateTime": "2025-01-28T15:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Hobart",
                "State": "Tasmania",
                "KmPoint": "463.2",
                "OccurrenceTypes": "Rolling Stock Irregularity",
                "NDSOccurrenceId": 630421,
                "LineSectionId": 214962,
                "LineSectionName": "Main North Line",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 869214,
                "IsLocationMissing": false,
                "LocationDescription": "Near Main North Line",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Main North Line",
                    "LocationLine2": "",
                    "LocationLine3": "TAS"
                }
            },
            {
                "ONRSRRef": 999633,
                "OperatorRef": 809986,
                "OccurrenceStatusId": 2,
                "OccurrenceStatus": "Awaiting Final Submission",
                "ValidationStatus": "In Review",
                "ValidationStatusId": "2",
                "OccurrenceCategory": "C",
                "OccurrenceDateTime": "2025-01-29T16:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Sydney",
                "State": "New South Wales",
                "KmPoint": "428.6",
                "OccurrenceTypes": "Level Crossing Irregularity",
                "NDSOccurrenceId": 520870,
                "LineSectionId": 660827,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 987495,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "NSW"
                }
            },
            {
                "ONRSRRef": 643099,
                "OperatorRef": 131623,
                "OccurrenceStatusId": 4,
                "OccurrenceStatus": "Final",
                "ValidationStatus": "Validated",
                "ValidationStatusId": "4",
                "OccurrenceCategory": "A",
                "OccurrenceDateTime": "2025-01-30T06:00:00",
                "OccurrenceDateTimeStateTZ": "Australia/Brisbane",
                "State": "Queensland",
                "KmPoint": "122.7",
                "OccurrenceTypes": "Derailment",
                "NDSOccurrenceId": 132219,
                "LineSectionId": 620639,
                "LineSectionName": "Eastern Goldfields",
                "LevelCrossingSiteId": "0",
                "LevelCrossingId": "0",
                "DefinedLocationId": 182250,
                "IsLocationMissing": false,
                "LocationDescription": "Near Eastern Goldfields",
                "Ver_LineSectionId": "",
                "Ver_LineSectionName": "",
                "Ver_LevelCrossingSiteId": "",
                "Ver_LevelCrossingId": "",
                "Ver_DefinedLocationId": "",
                "LocationData": {
                    "LocationLine1": "Eastern Goldfields",
                    "LocationLine2": "",
                    "LocationLine3": "QLD"
                }
            }
        ]
}